import type { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { Portal } from '@sorare/core/src/atoms/layout/Portal';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { PillSwitchRarity } from '@sorare/marketplace/src/atoms/PillSwitchRarity';

type Props = {
  rarities: Rarity[];
  selectedRarity: Rarity;
  onChange: (rarity: Rarity) => void;
};

export const PoolRarityToggle = ({
  rarities,
  selectedRarity,
  onChange,
}: Props) => {
  if (!rarities.length) {
    return null;
  }

  return (
    <Portal id="above-bottom-bar-portal">
      <Horizontal center className="py-2">
        <PillSwitchRarity
          rarities={rarities}
          selectedRarity={selectedRarity}
          onChange={onChange}
        />
      </Horizontal>
    </Portal>
  );
};
